<template>
  <Checkbox v-bind="props" v-model="model">
    <template v-for="(slot, name) in $slots" #[name]="slotProps" :key="name">
      <component :is="slot" v-bind="slotProps" />
    </template>
  </Checkbox>
</template>

<script setup lang="ts">
import Checkbox, { type CheckboxSlots } from 'primevue/checkbox'
import type { CheckboxProps } from '.'

const props = defineProps<Omit<CheckboxProps, 'modelValue'>>()
const model = defineModel()

defineSlots<Partial<CheckboxSlots>>()
</script>
